"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplateChildrenTextOptions = exports.getTemplateChildrenQrCodeOptions = exports.getTemplateChildrenTextFit = exports.getObject = exports.removeNullValues = exports.getTemplateChildrenKey = exports.getTemplateChildrenLabel = exports.getTemplateChildrenStyles = void 0;
var ramda_1 = require("ramda");
var removeNullValues = function (styles) {
    if (styles) {
        Object.keys(styles).forEach(function (key) { return styles[key] == null && delete styles[key]; });
        return styles;
    }
    return {};
};
exports.removeNullValues = removeNullValues;
var getTemplateChildrenStyles = function (templateChildren, index, mediaKeys) {
    if (templateChildren instanceof Array) {
        var currentChild = templateChildren[index]; // undefined if styles not found
        var styles = (currentChild === null || currentChild === void 0 ? void 0 : currentChild.styles) ? removeNullValues(currentChild.styles) : {};
        return __assign(__assign({}, styles), ((currentChild === null || currentChild === void 0 ? void 0 : currentChild.backgroundImage) && mediaKeys
            ? { backgroundImage: "url(".concat(mediaKeys[currentChild.backgroundImage], ")") }
            : {}));
    }
    return {};
};
exports.getTemplateChildrenStyles = getTemplateChildrenStyles;
var getTemplateChildrenLabel = function (templateChildren, index) {
    var _a;
    var label = (_a = templateChildren[index]) === null || _a === void 0 ? void 0 : _a.label;
    return label || undefined;
};
exports.getTemplateChildrenLabel = getTemplateChildrenLabel;
var getTemplateChildrenKey = function (templateChildren, index) {
    return templateChildren && templateChildren.length >= index && (0, ramda_1.path)(['key'], templateChildren[index])
        ? templateChildren[index].key
        : undefined;
};
exports.getTemplateChildrenKey = getTemplateChildrenKey;
var getObject = function (obj, pathArray) { return (0, ramda_1.view)((0, ramda_1.lensPath)(pathArray), obj); };
exports.getObject = getObject;
/**
 * Get textFit properties from styles child
 * @param templateChildren
 * @param index
 */
var getTemplateChildrenTextFit = function (templateChildren, index) {
    var _a;
    if (templateChildren instanceof Array) {
        return (_a = templateChildren[index]) === null || _a === void 0 ? void 0 : _a.textFit;
    }
    return undefined;
};
exports.getTemplateChildrenTextFit = getTemplateChildrenTextFit;
var getTemplateChildrenQrCodeOptions = function (templateChildren, index) {
    var _a;
    if (templateChildren instanceof Array) {
        return (_a = templateChildren[index]) === null || _a === void 0 ? void 0 : _a.qrCodeOptions;
    }
    return undefined;
};
exports.getTemplateChildrenQrCodeOptions = getTemplateChildrenQrCodeOptions;
var getTemplateChildrenTextOptions = function (templateChildren, index) {
    var _a;
    if (templateChildren instanceof Array) {
        return (_a = templateChildren[index]) === null || _a === void 0 ? void 0 : _a.textOptions;
    }
    return undefined;
};
exports.getTemplateChildrenTextOptions = getTemplateChildrenTextOptions;
//# sourceMappingURL=styles.js.map